import { useState } from "react";
import "./modal.css";
import { FaPlusCircle } from "react-icons/fa";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
function Modal({
  customers,
  EditUser,
  Update,
  index,
  changeHandlerDaste,

  optionDasteBandi,
}) {
  const animatedComponents = makeAnimated();

  return (
    <>
      <div
        class="modal fade"
        id={`exampleModal`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data">
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label htmlFor="address-edit-user" className="title w-25">
                      وضعیت{" "}
                    </label>
                    <div className="w-75">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label" for="inlineRadio1">
                          فعال
                        </label>
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineRadio1"
                          value={customers[index].status}
                          onChange={(e) =>
                            EditUser((prev) => {
                              let temp = [...prev];
                              temp[index][e.target.name] = e.target.value;
                              return [...temp];
                            })
                          }
                          name="status"
                        />
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label" for="inlineRadio2">
                          غیر فعال
                        </label>
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineRadio1"
                          value={customers[index].status}
                          onChange={(e) =>
                            EditUser((prev) => {
                              let temp = [...prev];
                              temp[index][e.target.name] = e.target.value;
                              return [...temp];
                            })
                          }
                          name="status"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label
                      className="title w-25"
                      htmlFor="national-code-edit-user"
                    >
                      برچسب{" "}
                    </label>
                    <CreatableSelect
                      className="w-75 "
                      value={customers[index].barchasb}
                      onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}
                      options={optionDasteBandi}
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(customers);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;
{
  /* <input
type="text"
className="form-control"
value={customers[index].status}
onChange={(e) =>
  EditUser((prev) => {
    let temp = [...prev];
    temp[index][e.target.name] = e.target.value;
    return [...temp];
  })
}
name="status"
id="address-edit-user"
/>
</div> */
}
